import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { Button } from 'primeng/button';
import { InputText } from 'primeng/inputtext';
import { Navbar } from '../shared/navbar/navbar';
import { DemoAccessService } from './demo-access.service';

@Component({
    selector: 'app-demo-gate',
    imports: [Navbar, TranslatePipe, InputText, Button, ReactiveFormsModule],
    templateUrl: './demo-gate.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DemoGate {
    private readonly demoAccess = inject(DemoAccessService);
    private readonly router = inject(Router);

    readonly subdomain = this.demoAccess.subdomain;
    readonly loading = signal(false);
    readonly showError = signal(false);

    readonly form = new FormGroup({
        password: new FormControl<string>('', [Validators.required]),
    });

    constructor() {
        // Redirect away if this route is visited outside a demo subdomain
        if (!this.subdomain) {
            this.router.navigate(['/']);
        }
    }

    get passwordControl() {
        return this.form.get('password');
    }

    get passwordInvalid() {
        const control = this.passwordControl;
        return !!control?.invalid && (control.dirty || control.touched);
    }

    submit() {
        if (this.loading()) return;
        if (!this.form.valid) {
            this.form.markAllAsTouched();
            return;
        }

        this.loading.set(true);
        this.showError.set(false);

        const password = this.passwordControl?.value ?? '';
        const success = this.demoAccess.tryUnlock(password);

        this.loading.set(false);

        if (success) {
            const returnUrl = this.router.parseUrl(this.router.url).queryParams['returnUrl'] ?? '/';
            this.router.navigateByUrl(returnUrl);
        } else {
            this.showError.set(true);
        }
    }
}
